import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';

@Pipe({
  standalone: false,
  name: 'statusName',
  pure: false
})
export class StatusNamePipe implements PipeTransform {

  statusNames = {
    'Imported': { de: 'Importiert', en: 'Imported' },
    'AnalysisRequested': { de: 'Analyse', en: 'Analysis' },
    'AwaitingOrder': { de: 'Vorbereitet', en: 'Prepared' },
    'AwaitingSourcing': { de: 'In Bearbeitung', en: 'In progress' },
    'Sourcing': { de: 'In Bearbeitung', en: 'In progress' },
    'Completed': { de: 'Abgeschlossen', en: 'Completed' },
    'Paused': { de: 'Pausiert', en: 'Paused' },
    'Cancelled': { de: 'Abgebrochen', en: 'Cancelled' },
    'All': { de: 'Alle', en: 'All' }
  }

  constructor(private localization : LocalizationService) { }

  transform(value: any, ...args: unknown[]): unknown {

    const lang = this.localization.language;

    if (value.IsCancelled)
      return this.statusNames['Cancelled'][lang];

    if (value.IsPaused && value.Status != 'Completed')
      return this.statusNames['Paused'][lang];

    return this.statusNames[value.Status]?.[lang];
  }
}